import { connect } from 'react-redux'
import { isSubmitting } from 'redux-form'
import SubInvoice from './SubInvoice'

import { FORM_NAME } from './Form'

import componentDidMount from './Handlers/componentDidMount'
import onClickSubmit from './Handlers/onClickSubmit'

const mapStateToProps = (state) => ({
  subcontractors: state.core.subcontractors,
  users: state.core.users,
  submitting: isSubmitting(FORM_NAME)(state),
})

const actionCreators = {
  componentDidMount,
  onClickSubmit,
}

export default connect(mapStateToProps, actionCreators)(SubInvoice)
